import React, { useCallback, useMemo, useState } from "react";
import CrudForm from "../shared/crud/form";
import schema from "./domain/communicationAlert.schema.json";
import actions from "../../lib/actions";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { useProperty } from "../../components/property-provider";
import { useHttpClient } from "../../lib/http";
import { CommunicationAlertEntity } from "./domain/communicationAlert.entity";
import { getCommunicationAlert, updateCommunicationAlert } from "./infrastructure/communicationAlert.api";
import { IConfig, useConfig } from "../../lib/config";
import { regenPropertyCache } from "../common/api";
import { messages } from "./messages";
import { buildFormConfiguration } from "./domain/communicationAlert.formConfiguration";
import { CustomToast } from "../ariManagement/shared/toast";

function CommunicationAlertsForm() {
  const propertyInfo = useProperty();
  const configuration: IConfig = useConfig();
  const middlewareClient = useHttpClient(configuration.middlewareEndpoint);
  const apiClient = useHttpClient(configuration.secureApiEndpoint);

  const [toastType, setToastType] = useState<"success" | "error" | undefined>(undefined);

  const handleGetOne = useCallback(async () => {
    try {
      return await getCommunicationAlert(middlewareClient, propertyInfo.ticker);
    } catch (e) {
      setToastType("error");
      throw e;
    }
  }, [middlewareClient, propertyInfo.ticker]);

  const handleUpdate: (entity: CommunicationAlertEntity) => Promise<void> = useCallback(
    async entity => {
      await updateCommunicationAlert(propertyInfo.ticker, entity, middlewareClient);
      await regenPropertyCache(apiClient, propertyInfo.ticker);
      setToastType("success");
      return;
    },
    [apiClient, middlewareClient, propertyInfo.ticker]
  );
  const formConfiguration = useMemo(() => buildFormConfiguration(), []);

  return (
    <>
      <CrudForm<CommunicationAlertEntity>
        id={"emailAlertEntity"}
        schema={schema}
        formConfiguration={formConfiguration}
        messages={messages}
        onGet={handleGetOne}
        onUpdate={handleUpdate}
        canUpdate={actions.ModifyAppeareanceSettings}
        enumsOptional
      />
      <CustomToast show={!!toastType} type={toastType} onClose={() => setToastType(undefined)} />
    </>
  );
}

export default withAuthorizationVerifier(CommunicationAlertsForm);
